<template>
  <div>
    <b-container fluid class="fp-container bg-light-grey" v-if="!this.$route.params.kt">
      <Tiedot/>
    </b-container>
    <b-container fluid class="fp-container bg-white" v-if="userSelection.kayttotarkoitus !== null || this.$route.params.kt">
      <b-container>
        <b-row class="text-left">
          <b-col md="4">
            <el-select
              v-model="rakenne"
              placeholder="Valitse"
              @change="fetchReferences"
            >
              <el-option value="kaikki" label="Kaikki rakenteet"></el-option>
              <el-option value="rankarakenne" label="Rankarakenne"></el-option>
              <el-option value="massiivipuulevyrakenne" label="Massiivipuulevyrakenne"></el-option>
              <el-option value="pilari-palkkirakenne" label="Pilari-palkkirakenne"></el-option>
              <el-option value="hirsirakenne" label="Hirsirakenne"></el-option>
              <el-option value="hybridirakenne" label="Hybridirakenne"></el-option>
            </el-select>
          </b-col>
          <b-col>
            <template v-if="referenssit.length > 0">
              <small>{{kayttotarkoitus}}</small>
              <h2>Vertailukohteet</h2>

              <div class="chart-wrapper mb-5" style="height:400px">
                <v-chart ref="myChart" class="chart" :option="getScatterData" />
              </div>

              <el-table
                ref="filterTable"
                :data="referenssiTaulukko"
                :stripe="true"
                style="width: 100%">
                <el-table-column
                  prop="kohde"
                  label="kohde"
                  sortable
                >
                <template #default="{row}">
                  <a :href="row.linkki" target="_blank" v-if="row.linkki.length>0">{{ row.kohde }}</a>
                  <span v-else>{{ row.kohde }}</span>
                </template>
                </el-table-column>
                <el-table-column
                  prop="kustannus"
                  label="kustannus"
                  sortable
                  :formatter="priceFormatter"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="neliohinta"
                  label="€/m²"
                  sortable
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="vuosi"
                  label="vuosi"
                  sortable
                  width="100"
                >
                </el-table-column>
              </el-table>

              <!--
              <table class="table table-striped">
                <tr>
                  <th>kohde</th>
                  <th>kustannus</th>
                  <th>€/m<sup>2</sup></th>
                  <th>vuosi</th>
                </tr>
                <tr v-for="(item,index) in referenssit" :key="index">
                  <td><a :href="item.acf.referenssi_linkki" target="_blank" class="">{{item.title.rendered}}</a></td>
                  <td>{{ formatNumber( indexCorrect(item.acf.valmistumisvuosi, item.acf.investointikustannus), {}) }}</td>
                  <td>{{ indexCorrect(item.acf.valmistumisvuosi, item.acf.neliokohtainen_kustannus) }} €/m<sup>2</sup></td>
                  <td>{{item.acf.valmistumisvuosi}}</td>
                </tr>
              </table>
              -->
            </template>

            <b-card title="Taustaa tiedoille" v-if="referenssit.length > 0" class="mt-5">
              <ul>
                <li>Kustannukset sisältävät rakennus- ja suunnittelukustannukset ilman tonttia, liittymiä, kalusteita ja varusteita.</li>
                <li>Kustannukset on indeksikorjattu vuoden 2023 tasoon (rakennuskustannusindeksi 2005 = 100 ja 2023 = 150,6).</li>
              </ul>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="referenssit.length ===  0">
          <b-col>
            <h2 class="pt-3">Valitettavasti järjestelmässämme ei ole kustannustietoja valintojesi mukaiselle kohteelle.</h2>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import Tiedot from '../components/Tiedot'
import kayttotarkoitukset from '../data/kayttotarkoitukset.js'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { ScatterChart } from 'echarts/charts'
import {
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  ScatterChart,
  GridComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  name: 'Kustannukset',
  components: {Tiedot, VChart},
  provide: {
    [THEME_KEY]: 'light'
  },
  data () {
    return {
      referenssit: [],
      referenssiTaulukko: [],
      kayttotarkoitukset: kayttotarkoitukset,
      rakenne: 'kaikki',
      rakennuskustannusideksi: [
        100.0, // 2005
        103.8,
        109.9,
        114.2,
        113.0,
        114.2, // 2010
        118.0,
        122.1,
        123.3,
        123.9,
        124.5, // 2015
        124.9,
        127.7,
        129.0,
        128.7,
        135.7, // 2020
        141.8,
        149.3,
        151.0, // 2023
        151.0 // 2024
      ],
      currentIndex: 151.0
    }
  },
  mounted: function () {
    this.fetchReferences()
  },
  methods: {
    fetchReferences () {
      let cat
      if (this.userSelection.kayttotarkoitus !== null) {
        cat = this.kayttotarkoitukset[this.userSelection.kayttotarkoitus].category
      }
      if (this.$route.params.kt) {
        cat = this.$route.params.kt.split('-')[1]
      }

      var rak = this.rakenne
      let params = {
        'filter[posts_per_page]': 100,
        'filter[category_name]': cat,
        rest_route: '/wp/v2/posts'
      }

      if (rak !== 'kaikki') {
        params = {
          'filter[posts_per_page]': 100,
          'filter[category_name]': cat,
          'filter[kohteenrakenne]': rak,
          rest_route: '/wp/v2/posts'
        }
      }

      this.axios
        .get('https://epuu.fi/', {params})
        .then(response => {
          this.referenssit = response.data.filter(item => item.acf.investointikustannus > 0 && item.acf.neliokohtainen_kustannus > 0)
          this.referenssiTaulukko = []
          this.referenssit.forEach(item => {
            this.referenssiTaulukko.push(
              {
                'kohde': item.title.rendered,
                'kustannus': this.indexCorrect(item.acf.valmistumisvuosi, item.acf.investointikustannus),
                'vuosi': item.acf.valmistumisvuosi,
                'neliohinta': this.indexCorrect(item.acf.valmistumisvuosi, item.acf.neliokohtainen_kustannus),
                'linkki': item.acf.referenssi_linkki
              })
          })
        })
        .catch(error => {
          console.error(error)
        })
    },
    indexCorrect (year, value) {
      var yearInd = year - 2005 - 1
      var index = this.rakennuskustannusideksi[yearInd]
      var result = (this.currentIndex / index) * value
      return Math.round(result)
    },
    formatNumber (val) {
      return Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(val)
    },
    priceFormatter (row, column) {
      return this.formatNumber(row.kustannus)
    },
    onRowClick (row, column, event) {
      console.debug(row.linkki)
    },
    refreshChart () {}
  },
  computed: {
    kayttotarkoitus: function () {
      return this.userSelection.kayttotarkoitus != null ? this.kayttotarkoitukset[this.userSelection.kayttotarkoitus].label : ''
    },
    getScatterData: function () {
      let option = {
        tooltip: {
          trigger: 'item',
          alwaysShowContent: false,
          formatter: function (params) {
            return `<strong>${params.data[2]}</strong><br />${params.data[1]} €/m²`
          }
        },
        xAxis: {
          name: 'm²',
          axisLabel: {
            formatter: function (value, index) {
              return value
            }
          }
        },
        yAxis: {
          name: '€/m²',
          axisLabel: {
            formatter: function (value, index) {
              return value
            }
          }
        },
        series: [
          {
            symbolSize: 20,
            data: this.formatChartData,
            type: 'scatter'
          }
        ]
      }
      return option
    },
    formatChartData: function () {
      let data = []
      this.referenssit.forEach(item => {
        let area = item.acf.investointikustannus / item.acf.neliokohtainen_kustannus
        let datapoint = [area, this.indexCorrect(item.acf.valmistumisvuosi, item.acf.neliokohtainen_kustannus), item.title.rendered]
        data.push(datapoint)
      })
      return data
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Kustannukset.vue